<template>
    <!-- 审核状态栏 -->
    <div v-if="has_verify">
        <success-icon v-if="!deny_order" :text="verify_status" />
        <danger-icon v-else :text="verify_status" />
    </div>
    <div v-else><warning-icon :text="verify_status"/></div>
</template>

<script>
    import SuccessIcon from "./SuccessIcon"
    import DangerIcon from "./DangerIcon"
    import WarningIcon from "./WarningIcon"

    export default {
        name: "VerifyCol",
        components: {DangerIcon, SuccessIcon,WarningIcon},
        props: {
            order: Object
        },
        computed: {
            /**
             * 是否填写了审核单
             * @returns {verifyorder|{result, created_time, mdf_time, created_user, remark, result_display, use_duration, is_over_time}|data.verifyorder|{result, remark}|data.verifyorder}
             */
            has_verify() {
                return this.order.verifyorder
            },
            deny_order() { // 审核不通过
                return this.order.verifyorder.result === 'END'

            },
            verify_status() {
                if (this.has_verify) {
                    return this.order.verifyorder.result_display
                } else {
                    return '待审核'
                }
            },
        },
    }
</script>

<style scoped>

</style>